<template>
  <div class="users-create" v-loading="loading">
    <el-form v-if="!$route.params.company">
      <el-form-item label="Email">
        <el-input v-model="form.email" placeholder="Email"/>
      </el-form-item>
      <el-radio-group v-model="form.rules">

        <el-radio label="admin">Администратор</el-radio>
        <el-radio label="editor">Редактор</el-radio>
        <el-radio label="worker">Стандартный</el-radio>
      </el-radio-group>
      <div class="users-create__buttons">
        <el-button @click="$router.go(-1)">Отмена</el-button>
        <el-button type="primary" @click="save">Пригласить</el-button>
      </div>
    </el-form>
    <el-form v-else>
      <el-form-item label="Название">
        <el-input v-model="company.name" placeholder="Название"/>
      </el-form-item>
      <el-form-item label="Комментарий">
        <el-input v-model="company.comment" type="textarea" textarea/>
      </el-form-item>
      <div class="users-create__buttons">
        <el-button @click="$router.go(-1)">Отмена</el-button>
        <el-button type="primary" @click="createCompany">Добавить</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import crypto from 'crypto';
import {v4 as uuidv4} from 'uuid';

export default {
  name: 'Create',

  data() {
    return {
      loading: false,
      form: {
        rules: 'worker',
        email: '',
      },
      company: {
        name: '',
        comment: '',
      },
    };
  },

  methods: {
    async createCompany() {
      await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .add({
          uid: uuidv4(),
          position: '',
          name: this.company.name.trim(),
          email: firebase.auth().currentUser.email,
          phone: null,
          comment: this.company.comment,
          company: this.company.name.trim(),
          role: 'worker',
          isCompany: true,
          isInvited: true,
        }).then(() => {
          this.$router.push('/dashboard/users')
          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Компания создана',
            type: 'success',
          });
        });;
    },
    save() {
      const isEmpty = Object.values(this.form).some(x => (!x || x.length < 1));
      if (isEmpty) {
        this.$notify({
          offset: 60,

          title: 'Ошибка',
          message: 'Заполните все поля',
          type: 'error',
        });
        return false;
      }

      this.loading = true;
      const path = firebase.firestore().collection('invites');
      path
        .where('email', '==', String(this.form.email.replace(/\s/g, '')).toLowerCase())
        .where('projectId', '==', this.$store.state.project.id)
        .limit(1).get().then((doc) => {
        const token = crypto.randomBytes(36).toString('hex');
        if (doc.size > 0) {
          doc.forEach((d) => {
            d.ref.delete();
          });
        }
        setTimeout(() => {
          firebase.firestore().collection('invites').add({
            projectId: this.$store.state.project.id,
            ...this.form,
            email: String(this.form.email).replace(/\s/g, '').toLowerCase(),
            hash: token,
          }).then(() => {
            const proxy = firebase.functions().httpsCallable('onMailInvites');
            proxy(
              {
                projectId: this.$store.state.project.id,
                invites: [{
                  token: token,
                  email: String(this.form.email).replace(/\s/g, '').toLowerCase(),
                }],
              },
            ).finally(() => {
              this.$notify({
                offset: 60,

                title: 'Успешно!',
                message: 'Приглашение выслано',
                type: 'success',
              });
            });

            this.form = {
              rules: '',
              email: '',
            };
          }).finally(() => this.loading = false);
        }, 500);
      }).catch((error) => {
        this.$notify({
          offset: 60,

          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.users-create {
  max-width: 412px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 50px;
  @media screen and (max-width: 764px) {

    .el-radio-group {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      .el-radio {
        margin-bottom: 10px;
      }
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/Create.vue